export default "__VITE_ASSET__Cp2cg1P5__"